import { render, staticRenderFns } from "./Scholarship.vue?vue&type=template&id=6a1aaafd&"
import script from "./Scholarship.vue?vue&type=script&lang=js&"
export * from "./Scholarship.vue?vue&type=script&lang=js&"
import style0 from "./Scholarship.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports